/* global yaCounter77845462 */
import vars from './helpers';

function clearText(text) {
	return text.toString().trim().replace(/\s+/, ' ');
}

function spentOnPage15sec() {
	clearTimeout(vars.$window.data('timeout15Sec'));

	vars.$window.data('timeout15Sec', setTimeout(() => {
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	}, 15000));
}

function virtualHit(path) {
	if (window.ga) {
		ga('set', 'page', path);
		ga('send', 'pageview', path);
	}

	if (window.yaCounter77845462) {
		yaCounter77845462.hit(path);
	}
}

vars.$document.on('virtual-hit', () => {
	spentOnPage15sec();
	virtualHit(`/${window.location.hash}`);
})

// Menu and elements
$('.header__icon--left').on('click', () => {
	ga('send', 'event', 'nav', 'kp logo header');
});

$('.header__burger').on('click', (e) => {
	let $headerCurrent = $(e.currentTarget).closest('.header');

	if ($headerCurrent.hasClass('is-nav')) {
		ga('send', 'event', 'nav', 'menu close');
	} else {
		ga('send', 'event', 'nav', 'menu open');
	}
});

$('.header__link').on('click', (e) => {
	let $textCurrent = $(e.currentTarget).text();

	ga('send', 'event', 'nav', 'menu item click', clearText($textCurrent));
});

$('.begin__on').on('click', () => {
	ga('send', 'event', 'nav', 'start screen sound', 'Yes');
});

$('.begin__off').on('click', () => {
	ga('send', 'event', 'nav', 'start screen sound', 'No');
});

$('.header__icon--right').on('click', () => {
	ga('send', 'event', 'nav', 'music click');
});

$('.aside__next').on('click', () => {
	ga('send', 'event', 'nav', 'bottom click');
});

// Screens
$('.professions').on('click', '.professions__prev', () => {

	ga('send', 'event', 'professii', 'prevnext material');
});

$('.professions').on('click', '.professions__next', () => {

	ga('send', 'event', 'professii', 'prevnext material');
});

$('.stories').on('click', '.stories__next', () => {
	if ($('.popup').hasClass('is-active')) {
		ga('send', 'event', 'istorii', 'prevnext material');
	}
});

$('.discoveries').on('click', '.discoveries__next', () => {
	if ($('.popup').hasClass('is-active')) {
		ga('send', 'event', 'otkrytiya', 'prevnext material');
	}
});

$('.achievements').on('click', '.achievements__next', () => {
	if ($('.popup').hasClass('is-active')) {
		ga('send', 'event', 'dostizheniya', 'prevnext material');
	}
});

$('.achievements').on('click', '.achievements__circle--next', () => {
	ga('send', 'event', 'dostizheniya', 'start click');
});

$('.professions').on('click', '.professions__dot', (e) => {
	let tagret = $(e.currentTarget);
	let name = tagret.closest('.professions__content').find('.professions__slide.swiper-slide-active .professions__title').text();

	ga('send', 'event', 'istorii', 'click preview', clearText(name));
});

$('.stories').on('click', '.stories__slide', (e) => {
	let tagret = $(e.currentTarget);
	let name = `${tagret.find('.stories__name').text()} ${tagret.find('.stories__surname').text()}`;

	ga('send', 'event', 'istorii', 'click preview', clearText(name));
	ga('send', 'event', 'istorii', 'show material', clearText(name), {nonInteraction: false});
});

$('.discoveries').on('click', '.discoveries__content', (e) => {
	let tagret = $(e.currentTarget);
	let name = tagret.find('.discoveries__title').text();

	ga('send', 'event', 'otkrytiya', 'click preview', clearText(name));
	ga('send', 'event', 'otkrytiya', 'show material', clearText(name), {nonInteraction: false});
});

$('.achievements').on('click', '.achievements__event', (e) => {
	let tagret = $(e.currentTarget);
	let name = tagret.find('.achievements__year').text();

	ga('send', 'event', 'dostizheniya', 'click preview', clearText(name));
	ga('send', 'event', 'dostizheniya', 'show material', clearText(name), {nonInteraction: false});
});

$('.achievements').on('click', '.achievements__dot', (e) => {
	let tagret = $(e.currentTarget);
	let name = tagret.text();

	ga('send', 'event', 'dostizheniya', 'year list timeline click', clearText(name));
});

$('.achievements__bottom .achievements__prev').on('click', () => {
	ga('send', 'event', 'dostizheniya', 'year list timeline click', 'left');
});

$('.achievements__bottom .achievements__next').on('click', () => {
	ga('send', 'event', 'dostizheniya', 'year list timeline click', 'right');
});

$('.achievements__prev--big').on('click', () => {
	ga('send', 'event', 'dostizheniya', 'prev click');
});

$('.achievements__next--big').on('click', () => {
	ga('send', 'event', 'dostizheniya', 'next click');
});

$('.achievements__circle--test').on('click', () => {
	ga('send', 'event', 'dostizheniya', 'go to test');
});

$('.end__iri').on('click', () => {
	ga('send', 'event', 'nav', 'iri click');
});
1
vars.$document
	.on('home-screen-show', (e, id) => {
		let type = $(`.home-screen[data-screen='${id}']`).data('name');
		let name = '';
		let preview = $(`.home-screen[data-screen='${id}']`).find('.swiper-slide-active');

		if (id === 4) {
			name = `${preview.find('.stories__name').text()} ${preview.find('.stories__surname').text()}`;
		} else if (id === 3) {
			name = preview.find('.discoveries__title').text();
		} else if (id === 2) {
			name = preview.find('.achievements__year').text();
		} else if (id === 5) {
			name = $('.professions__slide.swiper-slide-active').find('.professions__title').text();

			ga('send', 'event', type, 'show material', clearText(name), {nonInteraction: false});

			return;
		} else if (id === 7) {
			ga('send', 'event', 'lastscreen', 'show');
	 	} else {
			return;
		}

		ga('send', 'event', type, 'show preview', clearText(name), {nonInteraction: true});
	})
	.on('slide-change-show', (e, id, type) => {
		let name = '';

		if ($('.popup').hasClass('is-active')) {
			setTimeout(() => {
				name = $('.popup.is-active .popup__title').text();

				ga('send', 'event', type, 'show material', clearText(name), {nonInteraction: false});
			}, 600);
		} else {
			if (id === 5 && $(`.home-screen[data-screen='${id}']`).hasClass('is-current')) {
				name = $('.professions__slide.swiper-slide-active .professions__title').text();

				ga('send', 'event', type, 'show material', clearText(name), {nonInteraction: false});

				return;
			} else if (id === 4 && $(`.home-screen[data-screen='${id}']`).hasClass('is-current')) {
				name = `${$('.stories__slide.swiper-slide-active .stories__name').text()} ${$('.stories__slide.swiper-slide-active .stories__surname').text()}`;
			} else if (id === 3 && $(`.home-screen[data-screen='${id}']`).hasClass('is-current')) {
				name = $('.discoveries__slide.swiper-slide-active .discoveries__title').text();
			} else if (id === 2 && $(`.home-screen[data-screen='${id}']`).hasClass('is-current')) {
				name = $('.achievements__slide.swiper-slide-active .achievements__year').text();
			} else {
				return;
			}

			ga('send', 'event', type, 'show preview', clearText(name), {nonInteraction: true});
		}
	});

// Test
let testPhotoSuccess = false;

$('.test__button--upload').on('click', () => {
	ga('send', 'event', 'test', 'download photo click');
});

$('.test__button--cropper-get').on('click', () => {
	ga('send', 'event', 'test', 'download photo change');
});

$('.test__button--cropper-on').on('click', () => {
	ga('send', 'event', 'test', 'download photo next');
});

vars.$document
	.on('test-start', () => {
		ga('send', 'event', 'test', 'start');
	})
	.on('test-question', (e, num, name) => {
		let text = clearText(name).substring(0, 100);

		ga('send', 'event', 'test', `question show ${num}`, `${text}`);
	})
	.on('test-answer', (e, num, correct, answer) => {
		ga('send', 'event', 'test', `question answer ${num}`, `${correct ? 'Yes' : 'No'} - ${answer}`);
	})
	.on('test-promt', (e, num, promt) => {

		ga('send', 'event', 'test', `prompt answer ${num}`, `${promt}`, 1);
	})
	.on('test-result', (e, result, count) => {
		let text = clearText(result).substring(0, 100);

		ga('send', 'event', 'test', 'finish', text, count);
	})
	.on('test-repear', () => {
		ga('send', 'event', 'test', 'resume');
	})
	.on('test-photo-success', () => {
		testPhotoSuccess = true;

		ga('send', 'event', 'test', 'download photo success');
	});

$('.test__social').on('click', (e) => {
	let name = $(e.currentTarget).data('name');

	ga('send', 'event', 'share', 'test final share', `${name} | ${testPhotoSuccess ? 'WITH_PHOTO' : 'WITHOUT_PHOTO'}`);
});

$('.share__button').on('click', (e) => {
	let name = $(e.currentTarget).data('social');

	ga('send', 'event', 'share', 'project share', name);
});
